import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, getToken, setToken } from "../lib/api";

const AdminContext = createContext({
  authenticated: false,
  loading: true,
  login: async () => false,
  logout: () => {},
});

export const AdminProvider = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  const verify = useCallback(async () => {
    const t = getToken();
    if (!t) {
      setAuthenticated(false);
      setLoading(false);
      return;
    }
    try {
      await api.get("/admin/me");
      setAuthenticated(true);
    } catch (_e) {
      setAuthenticated(false);
      setToken(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    verify();
  }, [verify]);

  const login = useCallback(async (password) => {
    try {
      const { data } = await api.post("/admin/login", { password });
      if (data?.token) {
        setToken(data.token);
        setAuthenticated(true);
        return { ok: true };
      }
      return { ok: false, error: "Respuesta invalida" };
    } catch (e) {
      return { ok: false, error: e?.response?.data?.detail || "Error de autenticacion" };
    }
  }, []);

  const logout = useCallback(() => {
    setToken(null);
    setAuthenticated(false);
  }, []);

  return (
    <AdminContext.Provider value={{ authenticated, loading, login, logout }}>{children}</AdminContext.Provider>
  );
};

export const useAdmin = () => useContext(AdminContext);
